import React from "react";
import "./CreateDepartmentDialog.css";
import { Form } from "react-bootstrap";
import CamplaCoreService from "../../../../../../services/CamplaCoreService";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";
import MarkDownEditor from "../../../../../../components/markdownEditor/MarkDownEditor";

class CreateDepartmentDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      identifier: {
        defaultValue: "",
        rule: ValidationHelper.isNonEmptyString,
      },
      description: {
        defaultValue: ValidationHelper.getDefaultValueExtendedDescription(),
        initValid: false,
        rule: ValidationHelper.isNonEmptyExtendedDescription,
      },
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({
        validation: ValidationHelper.getValidation(this.validationDefinition),
      });
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={t("Organisation.DepartmentTabbar.CreateDepartmentDialog.Title")}
        dialogApiError={this.props.dialogApiError}
        leftButtonVariant="black"
        rightButtonVariant="green"
        rightButtonText={t(
          "Organisation.DepartmentTabbar.CreateDepartmentDialog.Submit"
        )}
        leftButtonText={t(
          "Organisation.DepartmentTabbar.CreateDepartmentDialog.Cancel"
        )}
        leftButtonCallback={this.onHide}
        rightButtonDisabled={!this.state.validation._isValid}
        body={
          <Form>
            <Form.Group controlId="formClassName">
              <Form.Label>
                {t(
                  "Organisation.DepartmentTabbar.CreateDepartmentDialog.Identifier"
                )}
              </Form.Label>
              <Form.Control
                type="text"
                name="identifier"
                placeholder={t(
                  "Organisation.DepartmentTabbar.CreateDepartmentDialog.NamePlaceholder"
                )}
                value={this.state.validation.identifier.value}
                isInvalid={!this.state.validation.identifier.isValid}
                onChange={this.handleChange}
              />
              <Form.Control.Feedback type="invalid">
                {t(
                  "Organisation.DepartmentTabbar.CreateDepartmentDialog.NamePlaceholder"
                )}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group>
              <MarkDownEditor
                defaultValue={ValidationHelper.getDefaultValueExtendedDescription()}
                onChange={(value) =>
                  this.handleChange({
                    target: {
                      name: "description",
                      value: value,
                    },
                  })
                }
                label={t(
                  "Organisation.DepartmentTabbar.CreateDepartmentDialog.Description"
                )}
              />
              <Form.Control
                type="hidden"
                isInvalid={!this.state.validation.description.isValid}
              />
              <Form.Control.Feedback type="invalid">
                {t("InstanceTemplates.Modal.Form.ValidationError.Description")}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        }
      />
    );
  }
}

export default withTranslation()(CreateDepartmentDialog);
